import Highcharts from 'highcharts';

// Force light mode - Highcharts 13 otherwise adapts charts to the OS dark scheme.
Highcharts.setOptions({ palette: { colorScheme: 'light' } });

window.Highcharts = Highcharts;